import React from 'react';
import { useLocation } from 'react-router-dom';

const Detail = () => {
  const location = useLocation();
  const { registerNumber, data } = location.state;
  const proposal = JSON.parse(data);
  return (
    <>
      <section className="pt-4 pb-50 content-min-height">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="section-title">
                <h5>Proposal</h5>
                {/* <h3>210710858</h3> */}
              </div>
              <div className="mt-4 about-cont">
                <div className="card border-info" style={{"borderTop": "3px solid"}}>
                  <div className="card-header"><h6>{registerNumber}</h6></div>
                  <div className="card-body">
                    <table className='table table-borderless'>
                      <tbody>
                        <tr>
                          <td>Name</td>
                          <td>:</td>
                          <td>{proposal.login_name}</td>
                        </tr>
                        <tr>
                          <td>Email</td>
                          <td>:</td>
                          <td>{proposal.login_user}</td>
                        </tr>
                        <tr>
                          <td>Status</td>
                          <td>:</td>
                          <td>{proposal.status}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Detail;